import React,{useState,useEffect} from "react";
import {FiX} from 'react-icons/fi';
import {get,post} from '../../store/config/register'
import { format } from 'date-fns';
import { toast } from "react-toastify";
import { empresa_Id } from "../../store/config/dadosuser";
import './ModalAgenda.css'
import { useHistory } from "react-router-dom";

const initialState ={
    agenda: {
      id: 0,
      responsavel: '',
      descricao: ''

    }
  }


export default function ModalAgenda({conteudo,close}) {
    
    const [horarios, setHorarios]=useState(conteudo.Horarios);
    const [horarioId,setHorarioId]=useState(0);
    const [agenda,setAgenda]=useState(initialState.agenda);
    const [maiorHoje,setMaiorHoje]= useState(false);
    const [templateEmail,setTemplateEmail]= useState(conteudo.template_email);
    const [emailParam,setEmailParam]= useState(conteudo.email_param);
    const [horario, setHorario] = useState(conteudo.Horario );
    const [horarioPadrao,setHorarioPadrao]= useState(conteudo.padrao)
    const history = useHistory();
    let diaSemana = 0;
    let data = new Date();

    if(conteudo.data !== undefined){
        diaSemana=conteudo.data.getDay()+1;
        data = conteudo.data;
        agenda.responsavel = conteudo.usuario.unidade + ' - '+conteudo.usuario.bloco

    }

    let hoje =new Date().setHours(0,0,0,0);
 
        useEffect(()=> {
            if(conteudo.data >= hoje) {
                setMaiorHoje(true);
            }
        },[])

    function  updateField(event){
        const age ={...agenda}
          
        age[event.target.name] =event.target.value
          setAgenda(age);
  }

  async function ExisteAgendamento(){
    let inicio="";
    if(horarios !== undefined){
         inicio=horarios.filter(f =>f.id === horarioId)[0].hora_Inicio
    }else {
        inicio =  horarioPadrao[0].hora_Inicio;
    }
    
   const res = await get('/EspacoAgenda/v1/Existe?espaco_id='+conteudo.espaco_id+'&inicio='+ format(conteudo.data,"yyyy-MM-dd ")+inicio);
   return res.existe;
}

    function renderSelectHorario(){    
        if(horarios !== undefined){
            return horarios.map(horario => {
                return (<option key={horario.id} value={horario.id}>{horario.id === 0 ? '' : `${horario.hora_Inicio} - ${horario.hora_Fim}`} </option>)
            })
        }        
    }

    function trocaHorario(e) {
        setHorarioId(parseInt(e.target.value));
    }

   async function salvarReserva() {
    if(maiorHoje){
        let existe = await ExisteAgendamento();
    if( existe === false) {
        let inicio="";
        if(horarios !== undefined){
             inicio=horarios.filter(f =>f.id === horarioId)[0].hora_Inicio
        }else {
            inicio =  horarioPadrao[0].hora_Inicio;
        }
        let dat ={ espaco_id: parseInt(conteudo.espaco_id), unidade_id: conteudo.usuario.unidade_Id,descricao: agenda.descricao, data: format(conteudo.data,"yyyy-MM-dd'T'")+inicio,hora_inicio: inicio,dia_semana: diaSemana, login_id: conteudo.login_id}

        await post('/EspacoAgenda/v1',dat);

        if (conteudo.termo) {
            await enviarEmail();
        }
        
        await toast.success('Agendamento realizado com sucesso.')
        history.push('/ReservaEspaco/'+conteudo.espaco_id)
        window.location.reload();
    }else {
        await toast.warning('Já existe um agendamento para este horário');

    }
    }else {
        await toast.warning('Não é possível fazer agendamentos para datas retroativas');

    }    
    }

    async function enviarEmail(Id){
        let emails =[];
        emails.push(emailParam.email);
       // emails.push('william@cisistemas.com.br');
         templateEmail.template =  templateEmail.template.replace('@unidade', `${conteudo.usuario.unidade} - ${conteudo.usuario.bloco}`); 
         templateEmail.template =  templateEmail.template.replace('@espaco', conteudo.espaco_nome);
         templateEmail.template =  templateEmail.template.replace('@espaco', conteudo.espaco_nome);    
         templateEmail.template =  templateEmail.template.replace('@nome', conteudo.usuario.nome); 
         templateEmail.template =  templateEmail.template.replace('@data', `${format(conteudo.data,'dd/MM/yyyy')}`); 
         let data =  { sender:emails, subject: templateEmail.assunto,html: templateEmail.template,empresa_id: empresa_Id}

         let result = await post('/Email/v1',data);
        await toast.success('email enviado com sucesso');
      }

    function template(usuario){
        let temp=`<html>
        <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <title>Troca de senha de usuário - Aplicativo do Condomínio - La Villete</title>
        </head>
		
         <body>
         <div bgcolor="#FFFFFF" marginwidth="0" marginheight="0">
			<center>
			
				<table width="640" border="0" cellpadding="0" cellspacing="0" align="center" bgcolor="#f5f5f5">
					<tr>
						<td>
							<table cellpadding="0" cellspacing="0" border="0" style="font-family:Calibri,sans-serif" width="100%">
							</table>

							<p>&nbsp;</p>
							
							 <table width="640" border="0" cellpadding="0" cellspacing="0" align="center" bgcolor="#f5f5f5">
								 <tr>
									 <td>
										 <table align="center" cellpadding="0" cellspacing="0" style="font-family:Calibri,sans-serif" width="720">
											 <tbody>
												 <tr>
													 <td style="padding:0px">
														 <center><a href="https://pt-br.facebook.com/condominiolavillette/" target="_blank" rel="noreferrer">
															 <img alt="Condomínio La Villette" src="https://condominio.cisuporte.com.br/imagens/logolavillete.png" width="50%" height="50%" 
															 style="display:block">
														 </a></center>
													 </td>
												 </tr>
											 </tbody>
										</table>
									</td>
								</tr>
										
								<tr>
									<td>								
										<h1 style="display:block;font-size:18px;color:#363636;margin:26px 15px;line-height:130%;font-family:Calibri,sans-serif;text-align:center;font-weight:400">
										 Olá Administração,</h1>
										 <h2 style="display:block;font-size:18px;color:#363636;margin:0px 25px 0px;line-height:130%;font-family:Calibri,sans-serif;text-align:center;text-transform:uppercase;font-weight:900">
											 ASSINATURA DO TERMO DE USO DO(A) ${conteudo.espaco_nome}
										 </h2>
										 <br />  
										 <h3 style="display:block;font-size:16px;color:#363636;margin:0px 25px 0px;line-height:130%;font-family:Calibri,sans-serif;text-align:center;text-transform:uppercase;font-weight:900">
										 ${usuario.nome}
										 </h3>
										 <h4 style="display:block;font-size:14px;color:#363636;margin:0px 25px 0px;line-height:130%;font-family:Calibri,sans-serif;text-align:center;text-transform:uppercase;font-weight:900">
										 ${usuario.unidade} - ${usuario.bloco}
										 </h4>
										 <p style="display:block;font-size:16px;color:#363636;margin:22px 25px;line-height:130%;font-family:Calibri,sans-serif;text-align:center">
										 Agendou o ${conteudo.espaco_nome} para o dia ${format(conteudo.data,'dd/MM/yyyy')}, será necessário a assinatura do termo de uso.<br>
										</p>
									</td>
								</tr>
								
								<tr style="margin-top:25px">
									<td>
										<div style="margin-top:25px">
										</div>
									</td>
								</tr>
										
								<tr>
								<td>
									<a href="https://pt-br.facebook.com/condominiolavillette/" 
										target="_blank" rel="noreferrer">
										<img alt="La Villette"	src="https://condominio.cisuporte.com.br/imagens/rodape_emm_lavillette_640x96.png" width="100%" height="100%">
									</a>
								</td> 
								</tr>
							</table>
						</td>
					</tr>			
				</table>
					<p>
                      <a href="https://acessoid.com.br/" target="_blank" rel="noreferrer"> Enviado por www.acessoid.com.br </a>
                    </p>
			</center>
		</div>
	</body>
</html>`;
 
        return temp;
       }


     return (
        <div>
            <div className="modal3">
                <div className="container">
                    <button className="closeAgenda" onClick={ close }>
                        <FiX size={23} color="#FFF" />
                        Voltar
                    </button>

                    <label>Dia:</label>
                    <label className="dia" name="responsavel" >{format(data,'dd/MM/yyyy') + " "+horarioPadrao[0].hora_Inicio} </label>

                    <div className="fieldAgenda">
                        <label>Responsável:</label>
                        <input className="form-control agendaResp" name="responsavel" value={agenda.responsavel} />
                    </div>

                    {horario === true  
                    && 
                    (
                        <div className="fieldAgenda">
                            <label>Hora:</label>
                            <select className="form-control agendaHora" onChange={(e) => trocaHorario(e)} value={horarioId}>{renderSelectHorario()}</select>
                        </div>

                    )}                   
                    <br />
                    
                    <button className="btn btn-primary btnCriar" onClick={() => salvarReserva()}>Criar Reserva</button>  
                </div>  

            </div>
             
        </div>      
     );
}